export const color = {
  primary: {
    hover: "#d98705",
    base: "#F29706",
  },
  secondary: {
    hover: "#579935",
    base: "#6EBE44",
  },
  tertiary: {
    hover: "#002044",
    base: "#59256B",
  },
  accent: {
    base: "#e5e5fd",
  },
  quaternary: {
    hover: "#195a8a",
    base: "#2071AD",
  },
  gray: {
    dark: "#69696F",
    base: "#D6DAE0",
    light: "#E6EBEE",
  },
  error: { base: "#EF4242", hover: "#ed3333" },
  body: { base: "#ffffff" },
  base: { base: "#59256B", light: "#9884A1", dark: "#2E063F" },
  black: { base: "#4A4A4B" },
};

export const font = {
  family: {
    base: "Prometo Webfont, sans-serif",
    head: "Prometo Webfont, sans-serif",
  },
  base: "16px",
  small: "14px",
  xsmall: "12px",
  large: "18px",
  xlarge: "20px",
  xxlarge: "22px",
  xxxlarge: "24px",
};
